import {
    call,
    put,
    takeEvery
} from "redux-saga/effects";
import Constants from "../../Action/Constants";
import { ActionInterface } from "../../Interface/ActionInterface";
import { ErrorHandlerSequence } from "../Sequences/ErrorHandlerSequence";
import Http from "../../Http/Http";
import PaymentFactory from "../../Entity/Factories/PaymentFactory";
import Store from "../../Store/Store";
import Time from "../../Time/Time";

export default function* paymentsSaveList(action: ActionInterface): any {
  try {
		let request = "payments?";

		typeof action.payload?.sortBy !== "undefined" ?
            request += `&sort_by=${action.payload?.sortBy}` : "sort_by=dateOfThePayment";

    typeof action.payload?.firstItem !== "undefined" ?
            request += `&first_item=${action.payload?.firstItem}` : request;

    typeof action.payload?.lastItem !== "undefined" ?
            request += `&last_item=${action.payload?.lastItem}` : request;

    typeof action.payload?.isFullyUsed !== "undefined" ?
            request += `&is_fully_used=${action.payload?.isFullyUsed}` : request;

    typeof action.payload?.paymentClassId !== "undefined" ?
            request += `&payment_class_id=${action.payload?.paymentClassId}` : request;

    typeof action.payload?.contactId !== "undefined" ?
            request += `&contact_id=${action.payload?.contactId}` : request;

    typeof action.payload?.companyId !== "undefined" ?
            request += `&company_id=${action.payload?.companyId}` : request;

    typeof action.payload?.chargeId !== "undefined" ?
            request += `&charge_id=${action.payload?.chargeId}` : request;

		typeof action.payload?.filterValue !== "undefined" ?
						request += `&q=${action.payload?.filterValue}` : request;

    typeof action.payload?.agencyBankAccount !== "undefined" && action.payload?.agencyBankAccount !== "all" ?
            request += `&agency_bank_account=${action.payload?.agencyBankAccount}` : request;

    typeof action.payload?.transactionFileId !== "undefined" ?
						request += `&transaction_file_id=${action.payload?.transactionFileId}` : request;

		typeof action.payload?.unusedAmount !== "undefined" ?
						request += `&amount_unused=${action.payload?.unusedAmount}` : request;

		typeof action.payload?.removed !== "undefined" ?
            request += `&removed=${action.payload?.removed}` : request;

    typeof action.payload?.isAfterStartDate !== "undefined" ?
            request += `&is_after_start_date=${action.payload?.isAfterStartDate}` : request;

    typeof action.payload?.date !== "undefined" ?
						request += `&date=${Time.formatOrNull(action.payload?.date)}` : request;
                                                
    typeof action.payload?.type !== "undefined" ? 
						request += `&payment_type_id=${action.payload?.type}` : request;	
                                                
    typeof action.payload?.isSnoozed !== "undefined" ?
						request += `&is_snoozed=${action.payload?.isSnoozed}` : request;

    typeof action.payload?.isBankTransaction !== "undefined" ?
						request += `&is_bank_transaction=${action.payload?.isBankTransaction}` : request; 
				
		typeof action.payload?.isProcessed !== "undefined" ?
						request += `&is_processed=${action.payload?.isProcessed}` : request; 

		typeof action.payload?.dashboard !== "undefined" ?
						request += `&dashboard=${action.payload?.dashboard}` : request; 

		typeof action.payload?.removeType !== "undefined" ?
						request += `&remove_type=${action.payload?.removeType.join(",")}` : request; 

    // if request was done should search for info in store
    if (!Store.getConfigurator().getState().payments?.requestsOutdated && Object.keys(Store.getConfigurator().getState().payments?.requests || {}).includes(request)) {
        return action.onSuccess.call(this,
        Store.getConfigurator().getState().payments.requests[request]);
    }
    const res = yield call(Http.get, request);

    const payments = res.data.rows.map(payment => {
      return PaymentFactory.create(payment);
    });

    const payload: any = {
      payments: payments,
      request: request,
      count: res.data.count
    };

    yield put({
      type: Constants.GLOBAL_PAYMENTS_SAVE_LIST_SUCCESS,
      payload: {...payload}
    });

    if (action.hasOwnProperty("onSuccess") === true) {
      action.onSuccess.call(this, {...payload});
    }
  } catch (err) {
    yield ErrorHandlerSequence(err, action);
  }
}

export function* watchPaymentsSaveList() {
  yield takeEvery(Constants.GLOBAL_PAYMENTS_SAVE_LIST, paymentsSaveList);
}
